import Vue from 'vue';
import Vuex from 'vuex';

import auth from './auth';
import article from './article';
import banner from './banner';
import tag from './tag';
import upload from './upload';
import menu from './menu';
import meta from './meta';

Vue.use(Vuex);

export default new Vuex.Store({
  strict: false,
  modules: {
    auth,
    article,
    banner,
    tag,
    upload,
    menu,
    meta,
  },
});
